export default {
  building: "Building",
  property: "Property",
  sale: "Sale"
};
